<div [ngClass]="{'layout-inline-menu': true, 'layout-inline-menu-active': true}"
     [ngStyle]="style" [class]="styleClass">
  <div *ngIf="section !== 'shortcuts'" class="layout-inline-menu-header" style="height: 10rem; width: 100%; position: relative"
       [ngStyle]="currentBackgroundStyles"
  >
    <a class="layout-inline-menu-action flex p-dir-row align-items-center" style="height: 100%;"
       [ngClass]="appMain.isHorizontal() ? 'p-3 p-lg:col-1 py-3' : 'p-3'"
       [pTooltip]="user.username" [tooltipDisabled]="isTooltipDisabled">
      <div style="padding-top: 5px">
        <app-thumbnail
          [imgSrc]="user.avatar | mediaObject" [circle]="true" [bordered]="true"
          stylesList="width: 62px; height: 62px;"
        ></app-thumbnail>
      </div>
      <div class="flex flex-column overflow-hidden width-100" [ngClass]="{'ml-2': !app.isRTL, 'mr-2': app.isRTL}">
            <span class="font-bold overflow-hidden text-overflow-ellipsis">{{ user?.username }}</span>
            <small class="overflow-hidden text-overflow-ellipsis">{{ user?.email }}</small>
        </div>
      <!--      <i class="layout-inline-menu-icon pi pi-angle-down"-->
      <!--         [ngClass]="{'ml-auto': !app.isRTL, 'mr-auto': app.isRTL}"></i>-->
    </a>
  </div>


  <ul *ngIf="section !== 'profile'" class="layout-inline-menu-action-panel" (click)="onClickNavigationElement()">
    <li class="layout-menuitem-text" [pTooltip]="'shared.inline_menu.profile' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      {{ 'common.shortcuts' | translate }}
    </li>
    <li class="layout-inline-menu-action-item" *ngxPermissionsOnly="['ROLE_ADMIN']"
        [pTooltip]="'shared.inline_menu.admin_dashboard' | translate" [tooltipDisabled]="isTooltipDisabled">
      <a [routerLink]="['/admin']" class="flex flex-row align-items-center" [attr.tabindex]="tabIndex">
        <i class="pi pi-lock"></i>
        <span>{{ 'shared.inline_menu.admin_dashboard' | translate }}</span>
      </a>
    </li>
    <li class="layout-inline-menu-action-item" [pTooltip]="'shared.inline_menu.garage' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      <a [routerLink]="['/', user.slug, 'garage']" class="flex flex-row align-items-center" [attr.tabindex]="tabIndex">
        <i class="pi pi-warehouse"></i>
        <span>{{ 'shared.inline_menu.garage' | translate }}</span>
      </a>
    </li>
    <li class="layout-inline-menu-action-item" [pTooltip]="'shared.inline_menu.profile' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      <a [routerLink]="['/', user.slug, 'profile']" class="flex flex-row align-items-center" [attr.tabindex]="tabIndex">
        <i class="pi pi-user pi-fw"></i>
        <span>{{ 'shared.inline_menu.profile' | translate }}</span>
      </a>
    </li>
    <li class="layout-inline-menu-action-item" [pTooltip]="'shared.inline_menu.settings' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      <a [routerLink]="['/', user.slug, 'settings']" class="flex flex-row align-items-center"
         [attr.tabindex]="tabIndex">
        <i class="pi pi-cog pi-fw"></i>
        <span>{{ 'shared.inline_menu.settings' | translate }}</span>
      </a>
    </li>
    <li class="layout-inline-menu-action-item" [pTooltip]="'shared.inline_menu.tutorials' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      <a [routerLink]="['/', user.slug, 'settings']" fragment="tutorials" class="flex flex-row align-items-center"
         [attr.tabindex]="tabIndex">
        <i class="pi pi-compass pi-fw"></i>
        <span>{{ 'shared.inline_menu.tutorials' | translate }}</span>
      </a>
    </li>
    <li class="layout-inline-menu-action-item" [pTooltip]="'shared.inline_menu.current_view_tutorial' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      <a href="#" class="flex flex-row align-items-center" [attr.tabindex]="tabIndex"
         (click)="startCurrentViewTutorial($event)">
        <i class="pi pi-directions pi-fw"></i>
        <span>{{ 'shared.inline_menu.current_view_tutorial' | translate }}</span>
      </a>
    </li>
    <li class="layout-menuitem-text" [pTooltip]="'shared.inline_menu.profile' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      {{ 'common.marketplace' | translate }}
    </li>
    <li class="layout-inline-menu-action-item" [pTooltip]="'shared.inline_menu.profile' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      <a [routerLink]="['/', user.slug, 'offers']" class="flex flex-row align-items-center" [attr.tabindex]="tabIndex">
        <i class="pi pi-gauge pi-fw" pBadge value="2" [badgeDisabled]="true"></i>
        <span>{{ 'shared.inline_menu.my_advertisements' | translate }}</span>
      </a>
    </li>
    <li class="layout-inline-menu-action-item" [pTooltip]="'shared.inline_menu.profile' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      <a [routerLink]="['/', user.slug, 'saved-offers']" class="flex flex-row align-items-center" [attr.tabindex]="tabIndex">
        <i class="pi pi-heart pi-fw" pBadge value="2" [badgeDisabled]="true"></i>
        <span>{{ 'shared.inline_menu.followed_advertisements' | translate }}</span>
      </a>
    </li>
    <li class="layout-inline-menu-action-item" [pTooltip]="'shared.inline_menu.profile' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      <a [routerLink]="['/', user.slug, 'saved-search-results']" class="flex flex-row align-items-center" [attr.tabindex]="tabIndex">
        <i class="pi pi-search pi-fw" pBadge value="2" [badgeDisabled]="true"></i>
        <span>{{ 'common.saved_search_results' | translate }}</span>
      </a>
    </li>
    <li class="layout-menuitem-text" [pTooltip]="'inspections.title' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      {{ 'inspections.title' | translate }}
    </li>
    <li *ngFor="let item of inspectionNavigationItems" class="layout-inline-menu-action-item"
        [pTooltip]="item.labelKey | translate" [tooltipDisabled]="isTooltipDisabled">
      <a [routerLink]="item.routerLink" class="flex flex-row align-items-center" [attr.tabindex]="tabIndex">
        <i [class]="item.icon + ' pi-fw'"></i>
        <span>{{ item.labelKey | translate }}</span>
      </a>
    </li>
    <li class="layout-menuitem-text" [pTooltip]="'shared.inline_menu.support' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      {{ 'shared.inline_menu.support' | translate }}
    </li>
    <li class="layout-inline-menu-action-item" [pTooltip]="'shared.inline_menu.report_bug' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      <a href="#" class="flex flex-row align-items-center" [attr.tabindex]="tabIndex" (click)="openBugReport($event)">
        <i class="fas fa-bug pi-fw"></i>
        <span>{{ 'shared.inline_menu.report_bug' | translate }}</span>
      </a>
    </li>
    <li class="layout-inline-menu-action-item" [pTooltip]="'shared.inline_menu.support' | translate"
        [tooltipDisabled]="isTooltipDisabled">
      <a [routerLink]="['/support']" class="flex flex-row align-items-center" [attr.tabindex]="tabIndex">
        <i class="pi pi-question-circle pi-fw"></i>
        <span>{{ 'shared.inline_menu.support' | translate }}</span>
      </a>
    </li>
  </ul>
</div>
